export default {
  MULTIPLE_CHOICE: {
    DEFAULT_OPTIONS: ['evet', 'hayır'],
    OFFLINE_MESSAGE:
      'Üzgünüm şu anda internetim yok. Bu nedenle cevabınızı işleme koyamıyorum.'
  }
}
